import { render, staticRenderFns } from "./BoxRank.vue?vue&type=template&id=279ace28&scoped=true"
import script from "./BoxRank.vue?vue&type=script&lang=js"
export * from "./BoxRank.vue?vue&type=script&lang=js"
import style0 from "./BoxRank.vue?vue&type=style&index=0&id=279ace28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ace28",
  null
  
)

export default component.exports